module.exports = __webpack_public_path__ + "static/media/Inspiron3.b6c98869.png";